// https://dev.to/sabbirsobhani/font-awesome-with-vuejs-3-59ee

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fab)
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(far)
import { dom } from "@fortawesome/fontawesome-svg-core"
dom.watch()

import {
  faTimes,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faTimes,
  faTimesCircle
)

export default FontAwesomeIcon
